import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Primitive } from '@epicuro-next/utilities';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface Choice {
  value: Primitive | null;
  label: string;
  isPrimary?: boolean;
}

@Component({
  selector: 'atx-generic-modal',
  templateUrl: './generic-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenericModalComponent {
  @Input()
  public title?: string;

  @Input()
  public message = '';

  @Input()
  public choices: Choice[] = [];

  constructor(public readonly modal: NgbActiveModal) {}

  public answer(choice: Choice): void {
    this.modal.close(choice.value);
  }
}
